module.exports = __webpack_public_path__ + "static/media/tree_structure.2bb3cb68.png";